import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import autosize from "autosize";

export class TextareaField extends Component {
  _input: ?HTMLInputElement;

  constructor(props) {
    super(props);
    this.state = {
      focus: false
    };
    this.onFocus = this.onFocus.bind(this);
    this.onBlur = this.onBlur.bind(this);
  }

  static propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    label: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    inputRef: PropTypes.func,
    className: PropTypes.string,
    disabled: PropTypes.bool
  };

  static defaultProps = {
    label: null,
    inputRef: () => null,
    className: "normal-input",
    disabled: false,
    id: Math.random()
      .toString(36)
      .substring(7)
  };

  componentDidMount() {
    autosize(document.querySelector("textarea"));
  }

  onFocus() {
    this.setState({
      focus: true
    });
  }

  onBlur() {
    this.setState({
      focus: false
    });
  }

  render() {
    const { id, name, label, value, onChange, inputRef, disabled } = this.props;
    const hasLabel = !!label;
    let className = `input-field field-type-textarea ${
      hasLabel ? "input-field-label" : ""
    }`;

    className += " " + this.props.className;

    return (
      <div
        className={classNames(className, {
          focus: this.state.focus,
          empty: !value,
          disabled: disabled
        })}
      >
        {hasLabel && <label htmlFor={id}>{label}</label>}
        <textarea
          ref={inputRef}
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          id={id}
          name={name}
          value={value ? value : ""}
          onChange={onChange}
          disabled={disabled}
        />
      </div>
    );
  }
}

export default TextareaField;
